// Session UI 状态：选中哪台 PC、当前 message stream、连接状态等。
import { signal } from "@preact/signals";
import type { Envelope, WSState } from "../transport/ws";
import { markAgentOffline, markAgentOnline } from "./agents";

export const selectedAgentId = signal<string | null>(null);
export const wsState = signal<WSState>("idle");
export const wsStateDetail = signal<string>("");
export const wsLog = signal<string[]>([]); // 调试用，最多 50 行

export interface ChatMsg {
  role: "user" | "assistant" | "system";
  text: string;
  ts: number;
  /** server message_id，仅 assistant 流式消息有 */
  messageId?: string;
  streaming?: boolean;
}
export const chat = signal<ChatMsg[]>([]);

export function pushLog(line: string) {
  const next = [...wsLog.value, `${new Date().toLocaleTimeString()} ${line}`];
  if (next.length > 50) next.shift();
  wsLog.value = next;
}

export function pushChat(m: ChatMsg) {
  chat.value = [...chat.value, m];
}

export function appendDelta(messageId: string, deltaText: string) {
  const list = [...chat.value];
  const last = list[list.length - 1];
  if (last && last.role === "assistant" && last.streaming && last.messageId === messageId) {
    last.text += deltaText;
    chat.value = list;
  } else {
    pushChat({
      role: "assistant",
      text: deltaText,
      ts: Date.now(),
      messageId,
      streaming: true
    });
  }
}

export function finalizeMessage(messageId: string) {
  const list = [...chat.value];
  for (const m of list) {
    if (m.messageId === messageId) m.streaming = false;
  }
  chat.value = list;
}

export function handleEnvelope(env: Envelope) {
  pushLog(`← ${env.type}`);
  if (env.type === "assistant_delta") {
    const p = env.payload as { message_id: string; delta_text: string };
    appendDelta(p.message_id, p.delta_text);
  } else if (env.type === "assistant_done") {
    const p = env.payload as { message_id: string; finish_reason?: string };
    finalizeMessage(p.message_id);
    if (p.finish_reason && p.finish_reason !== "stop" && p.finish_reason !== "end_turn") {
      pushChat({
        role: "system",
        text: `[done] finish_reason=${p.finish_reason}`,
        ts: Date.now(),
      });
    }
  } else if (env.type === "assistant_error") {
    const p = env.payload as { code: string; msg: string };
    pushChat({
      role: "system",
      text: `[agent error ${p.code}] ${p.msg}`,
      ts: Date.now(),
    });
  } else if (env.type === "agent_offline") {
    const p = env.payload as { agent_id: string; alias?: string };
    markAgentOffline(p.agent_id);
    pushChat({
      role: "system",
      text: `🔴 ${p.alias ?? p.agent_id} 离线（90s 无心跳）`,
      ts: Date.now(),
    });
  } else if (env.type === "agent_online") {
    const p = env.payload as { agent_id: string; alias?: string };
    markAgentOnline(p.agent_id);
    pushChat({
      role: "system",
      text: `🟢 ${p.alias ?? p.agent_id} 已重连`,
      ts: Date.now(),
    });
  } else if (env.type === "error") {
    pushChat({
      role: "system",
      text: `[error] ${JSON.stringify(env.payload)}`,
      ts: Date.now()
    });
  }
}
